module.exports = __webpack_public_path__ + "img/20190921101727338.5ca592e7.jpg";